import { render, staticRenderFns } from "./OutsideLayout.vue?vue&type=template&id=08d49798&"
import script from "./OutsideLayout.vue?vue&type=script&lang=js&"
export * from "./OutsideLayout.vue?vue&type=script&lang=js&"
import style0 from "./OutsideLayout.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports